import { faPage } from "@fortawesome/pro-regular-svg-icons"
import { faImage, faTrash } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { setActiveAppContext } from "app/tools/common"
import { CANCELED_REJECTION, IForm, IFormCreativeRow } from "form/model"
import { resetForm } from "form/tools/common"
import { deleteFormCreative } from "form/tools/creative-campaign"
import { getCampaignMedias } from "media/tools/common"
import { messageSVC } from "message/service"
import { CAMPAIGN_MEDIA_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"
import { CreativeDetailsPopup } from "./CreativeDetailsPopup"

interface ICreativeCampaignListActionsProps {
  campaignId: number
  form: IForm
  row: IFormCreativeRow
}

export const CreativeCampaignListActions = React.memo(
  ({ campaignId, form, row }: ICreativeCampaignListActionsProps): JSX.Element => {
    const [isDetailsPopupOpened, setIsDetailsPopupOpened] = React.useState(false)
    const [isDeleting, setIsDeleting] = React.useState(false)
    return (
      <FlexBox
        jc="start"
        gap
        fullWidth
        sx={{
          fontSize: "1.5rem"
        }}>
        {row.type === "archive" ? null : (
          <ListActionButton
            tooltip={translate("campaign.creative.show.details")}
            icon={faImage}
            disabled={isDetailsPopupOpened}
            onClick={event => setIsDetailsPopupOpened(true)}
          />
        )}
        <ListActionButton
          tooltip={translate("campaign.creative.delete")}
          icon={faTrash}
          isLoading={isDeleting}
          onClick={event => {
            setIsDeleting(true)
            deleteFormCreative(campaignId, row.mediaId, row.campaignMediaId).catch(error => {
              setIsDeleting(false)
              if (error === CANCELED_REJECTION) {
                return
              }
              console.error(error)
              messageSVC.error(translate("campaign.creative.delete.error"))
            })
          }}
        />
        {isDetailsPopupOpened && <CreativeDetailsPopup row={row} onClose={() => setIsDetailsPopupOpened(false)} />}
        {IS_NOT_PROD && (
          <ListActionButton
            // !! THIS ACTION BUTTON IS ONLY USED FOR TEST !!
            tooltip={translate("campaign.creative.show.full.details")}
            icon={faPage}
            onClick={async () => {
              const originalCampaignId = form.campaignId
              const medias = await getCampaignMedias(originalCampaignId)
              const media = medias.find(m => m.id === row.mediaId)
              if (!media) {
                messageSVC.warning(
                  "Unable to find media on the original campaign. Save the form and get back here to edit the creative"
                )
                return
              }
              if (typeof media.campaignMediaId !== "number") {
                messageSVC.error("Missing campaignMediaId on media!")
                return
              }
              navigate({ path: CAMPAIGN_MEDIA_PATH, pathParams: [originalCampaignId, media.campaignMediaId as number] })
              setActiveAppContext(null)
              resetForm(form.context.appContext)
            }}
          />
        )}
      </FlexBox>
    )
  }
)
